/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React from 'react';
import { FieldProps } from 'formik';
import Select, { MultiValueRemoveProps, components } from 'react-select';

interface Option {
  label: string;
  value: string;
}

interface SelectFieldProps extends FieldProps {
  options: any;
  isMulti?: boolean;
}

export const SelectField =
({
  field,
  form,
  options,
  isMulti = false,
}: SelectFieldProps) => {
  const onChange = (option: Option[] | Option['value']) => {
    form.setFieldValue(
      field.name,
      isMulti ? (option as Option[]).map((item: Option) => item.value) : option as Option['value']
    );
  };

  const getValue = () => {
    if (options && field.value) {
      return isMulti ?
        options.filter((option: any) => field.value.indexOf(option.value) >= 0) :
        options.find((option: any) => option.value === field.value);
    }
    return isMulti ? [] : '' as any;
  };

  const MultiValueRemove = (props: MultiValueRemoveProps) => {
    return (
      <components.MultiValueRemove {...props}>
        <svg xmlns='http://www.w3.org/2000/svg' width='18' height='18' viewBox='0 0 18 18' fill='none'>
          <path d='M13.5 4.5L4.5 13.5M4.5 4.5L13.5 13.5' stroke='#85888E' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'/>
        </svg>
      </components.MultiValueRemove>
    );
  };

  return (
    <Select
      styles={{
        control: (baseStyles, state) => ({
          ...baseStyles,
          'height': '100%',
          'backgroundColor':'#1A1B1E',
          'width': '100%',
          'border': 'none',
          'borderColor': 'none',
          ':focus': {
            borderColor: 'none'
          }
        }),
        container: (baseStyles) => ({
          ...baseStyles,
          height: '100%',
          backgroundColor:'#1A1B1E',
          width: '100%',
          border: '1px solid var(--Colors-Border-border-primary, #333741)',
          borderRadius: '8px',
          padding: '10px 14px'
        }),
        multiValue: (baseStyles) => ({
          ...baseStyles,
          display: 'flex',
          padding: 'var(--spacing-xs, 4px) var(--spacing-lg, 12px) var(--spacing-xs, 4px) var(--spacing-sm, 6px)',
          justifyContent: 'center',
          alignItems: 'center',
          gap: 'var(--spacing-sm, 6px)',
          borderRadius: '16px',
          background: '#2E3036',
          color: '#F5FAFF',
          fontFamily: 'Inter',
          fontSize: '14px',
          fontStyle: 'normal',
          fontWeight: '500',
          lineHeight: '20px',
        }),
        multiValueRemove: (baseStyles) => ({
          ...baseStyles,
          ':hover': {
            backgroundColor: 'transparent',
            cursor: 'pointer'
          }
        }),
        menu: (baseStyles) => ({
          ...baseStyles,
          background: '#1A1B1E',
          margin: '0px'
        }),
        option: (baseStyles) => ({
          ...baseStyles,
          display: 'flex',
          padding: '8px',
          justifyContent: 'center',
          alignItems: 'center',
          width: 'fit-content',
          margin: '12px',
          gap: 'var(--spacing-sm, 6px)',
          borderRadius: '16px',
          background: '#2E3036',
          color: '#F5FAFF',
          fontFamily: 'Inter',
          fontSize: '14px',
          fontStyle: 'normal',
          fontWeight: '500',
          lineHeight: '20px',
        })
      }}
      name={field.name}
      value={getValue()}
      onChange={onChange}
      options={options}
      isMulti={isMulti}
      theme={(theme) => ({
        ...theme,
        colors: {
          ...theme.colors,
          neutral0: '#333',
          primary25: '#004f81',
          neutral80: 'white',
          neutral10: '#004f81',
        },
      })}
      components={{ DropdownIndicator:() => null, IndicatorSeparator:() => null, MultiValueRemove: MultiValueRemove }}
    />
  );
};
